import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { BrowserCacheLocation, IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { isEmbeddedMode } from '@core/services/iframe.service';
import { environment } from 'src/environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.clientId,
      authority: environment.msalConfig.authority,
      redirectUri: globalThis.location.origin,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  protectedResourceMap.set(`${environment.apiUrl}/*`, [environment.msalConfig.scope]);
  protectedResourceMap.set(`${environment.adminApiUrl}/*`, [environment.msalConfig.adminScope]);
  protectedResourceMap.set('https://graph.microsoft.com/', ['User.Read']);

  return {
    interactionType: isEmbeddedMode() ? InteractionType.Popup : InteractionType.Redirect,
    protectedResourceMap,
  };
}
